import React, { useEffect } from 'react';
declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
    _fbq?: unknown;
  }
}
const PIXEL_ID = '3123699361155808';
const PIXEL_SCRIPT_ID = 'meta-pixel-script';
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined' || window.fbq) return;
    const pixel = function (...args: unknown[]) {
      pixel.queue.push(args);
    } as ((...args: unknown[]) => void) & {
      queue: unknown[][];
      loaded: boolean;
      version: string;
    };
    pixel.queue = [];
    pixel.loaded = true;
    pixel.version = '2.0';
    window.fbq = pixel;
    window._fbq = pixel;
    if (!document.getElementById(PIXEL_SCRIPT_ID)) {
      const script = document.createElement('script');
      script.id = PIXEL_SCRIPT_ID;
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return null;
}